import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function ProductCard({ product, index = 0 }) {
    return (
        <Link
            to={`/products/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="group relative flex flex-col bg-card border border-border rounded-xl overflow-hidden hover:border-cyan/50 transition-colors duration-500"
        >
            <div className="relative aspect-[4/3] bg-secondary overflow-hidden">
                <img
                    src={product.image}
                    alt={product.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
                <span className="absolute top-4 left-4 eyebrow glass rounded-full px-3 py-1 text-obsidian">
                    {product.category}
                </span>
                <span className="absolute top-4 right-4 grid place-items-center w-9 h-9 rounded-full bg-obsidian text-white opacity-0 group-hover:opacity-100 group-hover:rotate-45 transition-all duration-500">
                    <ArrowUpRight size={16} />
                </span>
            </div>
            <div className="p-6 flex flex-col gap-2 flex-1">
                <div className="flex items-baseline justify-between gap-3">
                    <h3 className="font-heading font-extrabold text-xl tracking-tight text-obsidian">{product.name}</h3>
                    <span className="font-mono-tech text-sm text-cyan whitespace-nowrap">${product.price?.toLocaleString()}</span>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">{product.short_description}</p>
            </div>
        </Link>
    );
}
